import React from "react";
import { GuaranteeViewData } from "./GuaranteeDataModel";

//icons
import ChatIcon from "../../assets/Icon_Chat.png";
import { PopoutImage } from "./GuaranteePanelReportSummary";

type Props = {
  details: GuaranteeViewData;
  report:boolean;
};
const GuaranteePanelAddressInfo: React.FC<Props> = ({ details, report=false }) => {
  return (
    <div className={`AddressInfo ${report?'increase-font':''}`}>
      {report?<h2>Address Info</h2>:<h4>Address Info</h4>}
      <table className="ViewTable">
        <thead>
          <tr>
            <th>Info type</th>
            <th>Details</th>
            {/* <th>Status</th> */}
            {/* <th>&nbsp;</th> */}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Country of residence </td>
            <td>{details.countryName ?? "-"}</td>
            {/* <td>&nbsp;</td> */}
            {/* <td><img src={ChatIcon} alt="ChatIcon" /></td> */}
          </tr>
          <tr>
            <td>Address</td>
            <td>{`${details.addressLine1 ?? "-"} ${
              details.addressLine2 ? `, ${details.addressLine2}` : ""
            }`}</td>
            {/* <td>&nbsp;</td> */}
            {/* <td><img src={ChatIcon} alt="ChatIcon" /></td> */}
          </tr>
          <tr>
            <td>City</td>
            <td>{details.townCity ?? "-"}</td>
            {/* <td>&nbsp;</td> */}
            {/* <td><img src={ChatIcon} alt="ChatIcon" /></td> */}
          </tr>
          <tr>
            <td>Zip code</td>
            <td>{details.postCode ?? "-"}</td>
            {/* <td>&nbsp;</td> */}
            {/* <td><img src={ChatIcon} alt="ChatIcon" /></td> */}
          </tr>
        </tbody>
      </table>
      {details.addressImageURI && (
        <PopoutImage url={details.addressImageURI} className="SummaryImage" />
      )}
    </div>
  );
};

export default GuaranteePanelAddressInfo;
